import * as React from "react";
import "./ErrorDialog.component.css";
import { useEffect, useState } from "react";
import { MessageService } from "../../services/message.service";
import { GenericDialog } from "../generic-dialog/GenericDialog.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
export function ErrorDialog() {
    const [isVisible, setIsVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [severity, setSeverity] = useState("error");
    const { t } = useTranslation();
    const showError = (message, severity) => {
        setErrorMessage(message);
        setSeverity(severity);
        setIsVisible(true);
    };
    useEffect(() => {
        MessageService.registerGlobalShowErrorFn(showError);
    }, []);
    return (React.createElement(React.Fragment, null, isVisible && (React.createElement(GenericDialog, { title: severity === "error" ? t("common:error-dialog-title-error", "Error") : t("common:error-dialog-title-warning", "Warning"), confirmText: t("common:error-dialog-button-confirm", "Close"), confirmAllowed: true, onCancel: () => { }, onConfirm: () => {
            setIsVisible(false);
        }, width: "narrow", hideCancel: true },
        React.createElement("div", { className: "error-dialog-content" },
            React.createElement(FontAwesomeIcon, { icon: ["fas", MessageService.getMessageIconName(severity)], size: "2x", className: `${severity}-color` }),
            React.createElement("span", null, errorMessage))))));
}
